var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "col-md-12 mb-2"
  }, [_c('div', {
    staticClass: "card-body1"
  }, [_c('b-card', [_c('div', [(_vm.admin == 'admin') ? _c('b-nav', {
    staticClass: "row",
    attrs: {
      "tabs": ""
    }
  }, [_c('b-nav-item', {
    staticClass: "col-3 tab",
    attrs: {
      "active": ""
    },
    on: {
      "click": function($event) {
        _vm.tabNavigation('module')
      }
    }
  }, [_vm._v("Module")]), _vm._v(" "), _c('b-nav-item', {
    staticClass: "col-3 tab",
    on: {
      "click": function($event) {
        _vm.tabNavigation('approval')
      }
    }
  }, [_vm._v("Approval")])], 1) : _vm._e(), _vm._v(" "), (_vm.admin != 'admin') ? _c('b-nav', {
    staticClass: "row",
    attrs: {
      "tabs": ""
    }
  }, [_c('b-nav-item', {
    staticClass: "col-3 tab",
    attrs: {
      "active": ""
    }
  }, [_vm._v("Approval")])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.selectedTab == 'module') ? _c('div', [_c('module')], 1) : _vm._e(), _vm._v(" "), (_vm.selectedTab == 'approval' || _vm.admin != 'admin') ? _c('div', [_c('approval')], 1) : _vm._e()])], 1)])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4cfae611","hasScoped":true}!./src/views/components/cargoclient/approvalflow/approvalflow.component.html
// module id = 550
// module chunks = 3